import axios from "@/repositories/client";
import default_room from "@/defaults/default-room";

axios.getRooms = (id, pagination, args = {}) => {

  args.dropdown = args.dropdown || false;

  let options = {
    params: {
      skip: pagination.size * (pagination.page - 1),
      take: pagination.size
    }
  };

  return axios.get(`athena/v1/hotels/${id}/room-types`, options)
    .then(response => {
      if(args.dropdown)
        return _.keyBy(response.data.data.map(room => ({text: room.name, value: room.id})), 'value');

      return response.data;
    });
};

axios.getRoom = (id, room) => {

  if (room === 'create')
    return new Promise((resolve => {
      resolve(_.cloneDeep(default_room));
    }));

  return axios.get(`athena/v1/hotels/${id}/room-types/${room}`)
    .then(response => {
      return response.data.data;
    });
};

axios.saveRoom = (id, room) => {
  let url = `athena/v1/hotels/${id}/room-types` + (room.id ? `/${room.id}` : '');
  let verb = room.id ? 'PUT' : 'POST';

  return axios.request({method: verb, url: url, data: room})
    .then(response => {
      return response.data.data;
    });
};

axios.destroyRoom = (hotel, room) => {
  return axios.delete(`athena/v1/hotels/${hotel}/room-types/${room}`)
    .then(response => {
      return response.data;
    });
};

export default axios;